import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FaChevronLeft } from 'react-icons/fa'

import { Box, Button, Dialog, Grid, Tooltip, useTheme } from '@mui/material'
import { Add } from '@mui/icons-material'

import { usePUT_addStudentToGroupMutation } from 'redux/api/groupsApi'
import { useGET_studentsProfileSelectQuery } from 'redux/api/studentsApi'

import { Form, Formik } from 'formik'

import SubmitButton from 'components/atoms/buttons/SubmitButton'
import SelectField from 'components/atoms/fields/SelectField'

import formModel, { initialValues, validationSchema } from 'utils/formModels/groupEnrollStudentModel'
import { crudColorMap, crudIconMap}  from 'utils/helpers'

import { ActionType, IGroupStudent } from 'types'

interface IProps {
  action: ActionType
  id: string
  viewOnly: boolean
}

const GroupEnrollStudentForm: FC<IProps> = ({ action, id, viewOnly }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  
  const [open, setOpen] = useState(false)
  const [enrollStudent, {isLoading}] = usePUT_addStudentToGroupMutation()
  const { student } = formModel()

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'right',
        alignItems: 'center',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
      }}
      className="transparent-background"
    >

      <Tooltip title={`${t('common.add')}`} arrow placement='top'>
        <Button
          variant='contained'
          color='success'
          aria-haspopup='true'
          onClick={() => setOpen(true)}
          disableElevation
          sx={{
            '&:hover': { background: theme.palette.success.main, border: 'none', '& svg': { color: '#000' } },
            height: '2.75rem',
            padding: '5',
            minWidth: 'auto',
            marginRight: '0.2rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 'none',
          }}
        >
          <Add
            sx={{ fontSize: '2rem', lineHeight: '1' }}
          />
          <span style={{ marginLeft: '0.5rem', display: 'inline-block' }}>{`${t(
                      'common.enroll-student',
                    )}`}</span>

        </Button>
      </Tooltip>


      <Dialog
                onClose={() => setOpen(false)}
                open={open}
                fullWidth
                maxWidth='md'
                PaperProps={{
                  sx: {
                    margin: 0,
                    padding: 10,
                    width: { xs: '100vw', md: '80vw' },
                    maxWidth: '600px',
                    background: theme.palette.background.default,
                  },
                }}
              >
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            const data: IGroupStudent = {
              group_id: parseInt(id),
              student_id: values.student.id,
            }
            enrollStudent(data)
          }}
        >
          <Form>
            <Grid container spacing={4} sx={{ marginTop: '-1rem' }}>

              <Grid item xs={12} lg={12}>
                <SelectField
                  fieldProps={{ ...student }}
                  apiCall={useGET_studentsProfileSelectQuery}
                  disabled={viewOnly}
                />
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ display: 'flex' }}>
                  <Button
                    variant='outlined'
                    color='black'
                    onClick={() => setOpen(false)}
                    sx={{ minHeight: '2.5rem', width: '10rem' }}
                  >
                    <FaChevronLeft style={{ fontSize: '1.1rem', margin: '-3px 0.5rem 0 -0.5rem' }} />
                    {`${t('common.back')}`}
                  </Button>
                  {action !== 'view' && (
                    <SubmitButton
                      color={crudColorMap[action]}
                      text={`${t('common.enroll-student')}`}
                      icon={crudIconMap[action]}
                      isLoading={isLoading}
                    />
                  )}
                </Box>
              </Grid>
            </Grid>
          </Form>
        </Formik>
      </Dialog>
    </Box>
  )
}
export default GroupEnrollStudentForm
